export default __webpack_public_path__ + "static/media/seguro-por-perdida-documentos.927ead4c.svg";